import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { MessageService } from 'primeng/components/common/messageservice';
import { ParkingTicketFilter } from '../models/parkingTicketFilter.model';
import { ParkingTicketReceiveMoney } from '../models/parkingTicketReceiveMoney.model';
import { InvoiceCustomer } from '../models/invoiceCustomer.model';



@Injectable()
export class ParkingTicketService extends GeneralService {
    constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
        super(messageService, httpClient, persistenceService, environment.apiPostUrl, "ParkingTicket");
    }

    async getListParkingTicket(filter: ParkingTicketFilter): Promise<any> {
        const res = await super.postCustomApi("GetList", filter).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async receiveMoney(model: ParkingTicketReceiveMoney): Promise<any> {
        const res = await super.postCustomApi("ReceiveMoney", model).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async parkingCalculate(hubId: any, vehicleTyeId: any, totalMonth: any, ticketId: any): Promise<any> {
        let params = new HttpParams();
        params = params.append("hubId", hubId);
        params = params.append("VehicleTyeId", vehicleTyeId);
        params = params.append("totalMonth", totalMonth);
        params = params.append("ticketId", ticketId);
        const res = await super.getCustomApi("Calculate", params).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async getParkingPaymentHistory(ticketId: any): Promise<any> {
        let params = new HttpParams();
        params = params.append("ticketId", ticketId);
        const res = await super.getCustomApi("PaymentHistory", params).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async parkingTicketCancel(ticketId: any, note: any): Promise<any> {
        let params = new HttpParams();
        params = params.append("ticketId", ticketId);
        params = params.append("note", note);
        const res = await super.getCustomApi("Cancel", params).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async getListReceiveMoney(model: any): Promise<any> {
        const res = await super.postCustomApi("ListReceiveMoney", model).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async confirmReceiveMoney(ids: any[]): Promise<any> {
        const res = await super.postCustomApi("ConfirmReceiveMoney", ids).toPromise();
        if (!this.isValidResponse(res)) return;
        return res;
    }

    async createInvoice(model: InvoiceCustomer): Promise<any> {
        const res = await super.postCustomApi("createInvoice", model).toPromise();
        return res;
    }

    async updateInvoice(model: InvoiceCustomer): Promise<any> {
        const res = await super.postCustomApi("updateInvoice", model).toPromise();
        return res;
    }

    async getListParkingInvoice(id: any) {
        let params = new HttpParams();
        params = params.append("invoiceId", id);
        const res = await super.getCustomApi("getListParkingInvoice", params).toPromise();
        return res;
    }
}